import type { QueryOptions } from "@tanstack/react-query"

import { Evaluate, ExactPartial, getAddress } from "viem"

import {
  GetAccountOwnerErrorType,
  GetAccountOwnerParameters,
  GetAccountOwnerReturnType,
  getAccountOwner,
} from "../actions/getAccountOwner"

import type { ExtendedConfig, ScopeKeyParameter } from "../types"
import { filterQueryOptions } from "../utils"

export type GetAccountOwnerOptions = Evaluate<
  ExactPartial<GetAccountOwnerParameters> & ScopeKeyParameter
>

export function getAccountOwnerQueryKey(options: GetAccountOwnerOptions = {}) {
  const { address, account, ...parameters } = options
  return [
    "address-from-account",
    filterQueryOptions({
      address: address ? getAddress(address) : undefined,
      account: account ? getAddress(account) : undefined,
      ...parameters,
    }),
  ] as const
}

export function getAccountOwnerQueryFn(
  config: ExtendedConfig,
  options: GetAccountOwnerOptions = {},
) {
  return getAccountOwner(config, options)
}

export function getAccountOwnerQueryOptions<config extends ExtendedConfig,>(
  config: config,
  options: GetAccountOwnerOptions,
) {
  return {
    gcTime: 0,
    queryFn: async ({ queryKey }) => {
      return getAccountOwnerQueryFn(config, queryKey[1])
    },
    queryKey: getAccountOwnerQueryKey(options),
  } satisfies QueryOptions<
    GetAccountOwnerQueryFnData,
    GetAccountOwnerErrorType,
    GetAccountOwnerData,
    GetAccountOwnerQueryKey
  >
}

export type GetAccountOwnerQueryFnData = GetAccountOwnerReturnType

export type GetAccountOwnerData = GetAccountOwnerQueryFnData

export type GetAccountOwnerQueryKey = ReturnType<typeof getAccountOwnerQueryKey>
